const l = () => {
  var e, t, a;
  return (a = (t = (e = document == null ? void 0 : document.querySelector("html")) == null ? void 0 : e.attributes) == null ? void 0 : t.getNamedItem("lang")) == null ? void 0 : a.value;
};
export {
  l as default,
  l as locale
};
